import * as React from "react";
const SvgRectRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 19, viewBox: "0 0 17 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H5L17 9.5L5 19H0V0Z", fill: "currentColor" }));
export default SvgRectRight;
